import { createContext, useContext } from 'react'

export const HostContext = createContext<string | null>(null)

export function useHost(): string | null {
  const ctx = useContext(HostContext)
  if (ctx !== null) return ctx
  if (typeof window !== 'undefined') return window.location.host
  return null
}

export function isBizHost(host: string | null | undefined): boolean {
  if (!host) return false
  return host.toLowerCase().startsWith('biz.carebalance.co.kr')
}
